<div class="color-bar"></div>

<div class="conteudo" *ngIf="!idOs">
  <div class="container-fluid cartoes" style="background-color: #fff;">
    <div class="row faixa-conteudo pt0">
      <div class="col col-lg-12">
        <div class="caixa">
          <div class="conteudo-caixa-sem-titulo sem-padding">

            <!-- Filtros de Dealers -->
            <div class="filtro-dash">
              <div>
                <div translate class="filtro ng-star-inserted" style="margin: 10px 22px 0px 0px;">
                  {{'analiseGarantia.dealers'}}
                </div>
                <span class="btn btn-outline-info btn-sm" *ngFor="let dealer of filtroDealers.selecionados()"
                  style="margin: 6px 2px 0px 2px; text-transform: uppercase;" (click)="removerDealer(dealer)">
                  {{dealer.nome}}
                  <i class="fa fa-times" aria-hidden="true" (click)="removerDealer(dealer)"></i>
                </span>
                <div class="botao">
                  <button class="btn btn-info btn-sm" (click)="selecionarDealer()">
                    <em class="fa fa-plus"></em>
                  </button>
                </div>
                <div class="clear"></div>
              </div>
            </div>
            <hr>

            <!-- Controles de Data e Filtros -->
            <div class="row ptb20">
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'rmpv.detalhado.dataInicial'}}
                </div>
                <p-calendar [(ngModel)]="data_inicial" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataInicial(data_inicial)"
                  (onSelect)="onDataInicialChange()"
                  placeholder="{{'rmpv.detalhado.placeHolderDataInicial' | translate}}" showButtonBar="true"
                  [readonlyInput]="true">
                </p-calendar>
              </div>
              <div class="col col-3">
                <div translate class="filtro ng-star-inserted" style="margin: 0px 10px 0px 0px;">
                  {{'rmpv.detalhado.dataFinal'}}
                </div>
                <p-calendar [(ngModel)]="data_final" dateFormat="dd/mm/yy" [showIcon]="true" icon="pi pi-calendar"
                  styleClass="p-iputtext-sm" [style]="{'minWidth':'100%'}" [yearNavigator]="true"
                  [monthNavigator]="true" yearRange="2000:2030" (onClearClick)="limpaDataFinal(data_final)"
                  (onSelect)="onDataFinalChange()"
                  placeholder="{{'rmpv.detalhado.placeHolderDataFinal' | translate}}" showButtonBar="true"
                  [readonlyInput]="true">
                </p-calendar>
              </div>
              <div class="col col-lg-6 col-md-12 mt-3">
                <div class="d-flex align-items-end justify-content-between flex-wrap">
                  <div class="d-flex flex-wrap">
                    <button type="button" class="btn btn-primary mr-2 mb-2" (click)="getAll()">
                      {{ 'analiseGarantia.filtros.filtrar' | translate }}
                      <i class="fas fa-search ml-1"></i>
                    </button>
                    <button class="btn btn-info mr-2 mb-2" type="button" (click)="showDialog()">
                      {{ 'analiseGarantia.filtros.maisFiltros' | translate }}
                      <em class="fa fa-filter ml-1"></em>
                    </button>
                  </div>
                  <div class="d-flex">
                    <button pButton class="p-button-outlined p-button-secondary p-button-sm mb-2" type="button"
                      (click)="exportExcel()">
                      <i class="fa fa-download mr-1"></i>{{ 'analiseGarantia.filtros.exportExcel' | translate }}
                    </button>
                  </div>
                </div>
              </div>
            </div>
            <hr>

            <!-- Botões para alternar tipo de análise -->
            <div class="row">
              <div class="col col-lg-8 col-md-12">
                <div class="d-flex flex-wrap">
                  <button pButton type="button"
                    (click)="alterarFiltro('pendentes')" 
                    [class.p-button-primary]="filtroAtivo === 'pendentes'"
                    [class.p-button-outlined]="filtroAtivo !== 'pendentes'"
                    class="p-button-sm p-button-secondary mr-2 mb-2 d-flex justify-content-center align-items-center"
                    style="min-width: 100px;">
                    {{ 'analiseGarantia.filtros.pendentes' | translate }}
                  </button>
                  <button pButton type="button"
                    (click)="alterarFiltro('aprovadas')"
                    [class.p-button-primary]="filtroAtivo === 'aprovadas'"
                    [class.p-button-outlined]="filtroAtivo !== 'aprovadas'"

                    class="p-button-sm p-button-secondary mr-2 mb-2 d-flex justify-content-center align-items-center"
                    style="min-width: 100px;">
                    {{ 'analiseGarantia.filtros.aprovadas' | translate }}
                  </button>
                  <button pButton type="button"
                    (click)="alterarFiltro('rejeitadas')"
                    [class.p-button-primary]="filtroAtivo === 'rejeitadas'"
                    [class.p-button-outlined]="filtroAtivo !== 'rejeitadas'"
                    class="p-button-sm p-button-secondary mr-2 mb-2 d-flex justify-content-center align-items-center"
                    style="min-width: 100px;">
                    {{ 'analiseGarantia.filtros.rejeitadas' | translate }}
                  </button>
                  <button pButton type="button"
                    (click)="alterarFiltro('todas')"
                    [class.p-button-primary]="filtroAtivo === 'todas'"
                    [class.p-button-outlined]="filtroAtivo !== 'todas'"
                    class="p-button-sm p-button-secondary mb-2 d-flex justify-content-center align-items-center"
                    style="min-width: 100px;">
                    {{ 'analiseGarantia.filtros.todas' | translate }}
                  </button>
                </div>
              </div>
            </div>

            <!-- Sub-abas para Ordens Aprovadas -->
            <div class="row" *ngIf="filtroAtivo === 'aprovadas'">
              <div class="col col-lg-8 col-md-12">
                <div class="d-flex flex-wrap" style="padding-left: 20px; border-left: 3px solid #007bff;">
                  <button pButton type="button"
                    (click)="alterarSubAbaAprovadas('emPagamento')"
                    [class.p-button-success]="subAbaAprovadas === 'emPagamento'"
                    [class.p-button-outlined]="subAbaAprovadas !== 'emPagamento'"
                    class="p-button-sm mr-2 mb-2 d-flex justify-content-center align-items-center"
                    style="min-width: 150px;">
                    {{ 'analiseGarantia.filtros.emPagamento' | translate }}
                  </button>
                  <button pButton type="button"
                    (click)="alterarSubAbaAprovadas('pagas')"
                    [class.p-button-success]="subAbaAprovadas === 'pagas'"
                    [class.p-button-outlined]="subAbaAprovadas !== 'pagas'"
                    class="p-button-sm mb-2 d-flex justify-content-center align-items-center"
                    style="min-width: 150px;">
                    {{ 'analiseGarantia.filtros.pagas' | translate }}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mr-2 ml-2 background">
      <p-table [columns]="columns" [value]="data" class="style" [paginator]="data?.length > 0 " [loading]="loading"
        [rows]="10" [showCurrentPageReport]="true" [rowsPerPageOptions]="[10,20,30,50,100]"
        (sortFunction)="customSort($event)" [customSort]="true"
        (onPage)="onPageChange($event)" [first]="first"
        currentPageReportTemplate="{{'analiseGarantia.mostrandoRegistros' | translate}}"
        styleClass="p-datatable-striped p-datatable-sm" [rowHover]="true" id="excel-table" [autoLayout]="false"
        [scrollable]="true" scrollDirection="horizontal">
        <ng-template pTemplate="colgroup">
          <colgroup>
            <col *ngFor="let col of columns" [style.width]="col.width">
          </colgroup>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <ng-container *ngFor="let col of columns">
              <th *ngIf="col.field == 'detalhe'" class="text-center">
                {{col.header}}
              </th>
              <th *ngIf="col.field == 'analise'" [ngStyle]="{'width': col.width}" class="text-center">
                {{col.header}}
              </th>
              <th *ngIf="col.field != 'detalhe' && col.field != 'analise'" [ngStyle]="{'width': col.width}"
                class="text-center" [pSortableColumn]="col.field" [translate]="getTranslate(col.header)">
                {{col.header}}
                <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
              </th>
            </ng-container>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-data let-columns="columns" let-rowIndex="rowIndex">
          <tr>
            <ng-container *ngFor="let col of columns">
              <td *ngIf="col.field == 'detalhe'" style="padding: 2px;">
                <button class="btn-ver" pTooltip="{{'rmpv.detalhado.verDetalhe' | translate}}"
                  (click)="visualizar(data)" style="cursor: pointer;">
                  <img src="assets/img/detail.png" />
                </button>
              </td>
              <td *ngIf="col.field == 'analise'" class="text-center">
              <button pButton type="button" class="p-button-raised p-button-info p-button-sm"
                (click)="abrirAnalise(data)" [disabled]="isAnalisarBloqueado(data)"
                [style.opacity]="isAnalisarBloqueado(data) ? 0.5 : 1" [attr.aria-disabled]="isAnalisarBloqueado(data)">
                {{ 'analiseGarantia.analise.botaoAnalise' | translate }}
              </button>
              </td>

              <td *ngIf="col.field == 'status'" class="text-center">
                {{ getStatusText(data.status) }}
              </td>
              <td *ngIf="col.field == 'data_analise' || col.field == 'data_emissao' || col.field == 'data_liberacao' || col.field == 'data_fechamento' || col.field == 'data_venda' || col.field == 'data_entrega' || col.field == 'data_ultimo_apontamento' || col.field == 'data_pagamento' || col.field == 'data_serv' || col.field == 'data_peca'" class="text-center">
                {{ data[col.field] != null && data[col.field] !== undefined ? (dataParaExibicao(data[col.field]) | date:'dd/MM/yyyy') || '-' : '-' }}
              </td>
              <td *ngIf="col.field == 'motivo_reprovacao'" class="text-center">
                {{ (data[col.field] && data[col.field].trim()) ? data[col.field].trim() : '-' }}
              </td>
              <td *ngIf="col.field != 'detalhe' && col.field != 'analise' && col.field != 'status' && col.field != 'data_analise' && col.field != 'data_emissao' && col.field != 'data_liberacao' && col.field != 'data_fechamento' && col.field != 'data_venda' && col.field != 'data_entrega' && col.field != 'data_ultimo_apontamento' && col.field != 'data_pagamento' && col.field != 'data_serv' && col.field != 'data_peca' && col.field != 'motivo_reprovacao'"
                class="text-center">
                {{(col.type && col.type.transform) ? col.type.transform(data[col.field], col.arg1) : (data[col.field] || '-')}}
              </td>
            </ng-container>
          </tr>
        </ng-template>
      </p-table>
    </div>
    <div class="emptymessage mr-2 ml-2">
      <div *ngIf="data?.length === 0" class="text-center">{{'analiseGarantia.grid' | translate}}</div>
    </div>
  </div>
</div>

<div *ngIf="idOs" class="conteudo container-fluid">
  <div class="float-top-right">
    <div class="btn-group btn-group-toggle barra" data-toggle="buttons">
      <label translate class="btn btn-secondary" (click)="voltar()">
        <em class="fa fa-arrow-left"></em> {{'rmpv.detalhado.voltar'}}
      </label>
    </div>
  </div>
  <app-os [id]="idOs"></app-os>
</div>

<!--Dialogs-->
<ng-container>
  <p-dialog class="top-dialog" [(visible)]="display" [modal]="true" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <h5 class="modal-title">{{'rmpv.detalhado.filtros.definirFiltros' | translate}}</h5>
    </ng-template>
    <ng-template pTemplate="body">

      <div class="container striped-rows">
        <div class="row ptb5">
          <div translate class="col col-4">
            {{'rmpv.detalhado.filtros.chassi'}}
          </div>
          <div class="col col-8">
            <input type="text" pInputText class="form-control form-control-sm"
              placeholder="{{'rmpv.detalhado.filtros.chassiPlaceHolder' | translate}}" [(ngModel)]="filtros.chassi">
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            {{'rmpv.detalhado.filtros.numeroOS'}}
          </div>
          <div class="col col-8">
            <input type="number" pInputText class="form-control form-control-sm"
              placeholder="{{'rmpv.detalhado.filtros.numeroOSPlaceHolder' | translate}}" [(ngModel)]="filtros.numero">
          </div>
        </div>
        <div class="row ptb5">
          <div translate class="col col-4">
            {{'rmpv.detalhado.filtros.status'}}
          </div>
          <div class="col col-8">
            <p-dropdown appendTo="body" placeholder="{{'rmpv.detalhado.filtros.statusPlaceHolder' | translate }}"
              [options]="status" optionLabel="nome" optionValue="valor" [(ngModel)]="status_os"
              [autoDisplayFirst]="false" [style]="{'minWidth':'100%'}" styleClass="p-inputtext-sm">
              <ng-template let-option pTemplate="item">
                {{ option.nome | translate }}
              </ng-template>
              <ng-template let-option pTemplate="selectedItem">
                {{ option.nome | translate }}
              </ng-template>
            </p-dropdown>
          </div>
        </div>

      </div>
    </ng-template>
    <ng-template pTemplate="footer">

      <button type="button" class="btn btn-info mt-1 pull-right" (click)="getAll()">OK</button>
      <button type="button" class="btn btn-outline-secondary mt-1 pull-right mr-1" (click)="cleanFilter()"><i
          class="fa fa-trash" aria-hidden="true"></i></button>
    </ng-template>
  </p-dialog>
</ng-container>

<!-- Dialog Análise -->
<ng-container>
  <p-dialog class="top-dialog" [(visible)]="displayAnalise" [modal]="true" [draggable]="false" [resizable]="false">
    <ng-template pTemplate="header">
      <h5 class="modal-title">{{ 'analiseGarantia.analise.titulo' | translate }}</h5>
    </ng-template>
    <ng-template pTemplate="body">
      <div class="container striped-rows" *ngIf="analiseEtapa === 'escolha'">
        <div class="row ptb5">
          <div class="col" translate>
            {{ 'analiseGarantia.analise.desejaAnalisar' }}
          </div>
        </div>
      </div>
      <div class="container striped-rows" *ngIf="analiseEtapa === 'rejeicao'">
        <div class="row ptb5">
          <div class="col col-12">
            <label class="form-label">{{ 'analiseGarantia.analise.motivoRejeicao' | translate }}</label>
            <textarea pInputTextarea class="form-control form-control-sm" rows="4"
              [placeholder]="'analiseGarantia.analise.informeMotivo' | translate" [(ngModel)]="mensagemRejeicao" name="mensagemRejeicao">
          </textarea>
          </div>
        </div>
      </div>
      <div class="container striped-rows" *ngIf="analiseEtapa === 'final'">
        <div class="row ptb5">
          <div class="col">
            <div class="alert alert-success" role="alert">
              <i class="fa fa-check-circle"></i>
              <span>{{ 'analiseGarantia.analise.processadaSucesso' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <ng-template pTemplate="footer">
      <ng-container *ngIf="analiseEtapa === 'escolha'">
        <button type="button" class="btn btn-success mt-1" (click)="aprovar()">{{ 'analiseGarantia.analise.aprovar' | translate }}</button>
        <button type="button" class="btn btn-danger mt-1" 
                [disabled]="registroSelecionado?.status === 2 || registroSelecionado?.status === '2'"
                [style.opacity]="(registroSelecionado?.status === 2 || registroSelecionado?.status === '2') ? 0.5 : 1"
                (click)="rejeitar()">{{ 'analiseGarantia.analise.rejeitar' | translate }}</button>
      </ng-container>
      <ng-container *ngIf="analiseEtapa === 'rejeicao'">
        <button type="button" class="btn btn-secondary mt-1 mr-1" (click)="cancelarAnalise()">{{ 'analiseGarantia.analise.cancelar' | translate }}</button>
        <button type="button" class="btn btn-danger mt-1" [disabled]="!mensagemRejeicao || !mensagemRejeicao.trim()"
          (click)="confirmarRejeicao()">{{ 'analiseGarantia.analise.confirmarRejeicao' | translate }}</button>
      </ng-container>
      <ng-container *ngIf="analiseEtapa === 'final'">
        <button type="button" class="btn btn-info mt-1" (click)="fecharAnalise()">{{ 'analiseGarantia.analise.fechar' | translate }}</button>
      </ng-container>
    </ng-template>
  </p-dialog>
</ng-container>

<!-- Componente modular para filtro de dealers -->
<app-filtro-dealers [(visible)]="displayFiltrosDealers" [dealers]="filtroDealers.dealers"
  [headerTitle]="'analiseGarantia.selecioneDealers'" [filterPlaceholder]="'analiseGarantia.filtrarDealers'"
  (dealerSelected)="onAdicionarDealerFiltro($event)">
</app-filtro-dealers>